

































import CondFormatEditor from "./CondFormatEditor.vue";

export default {
  name: "ColumnCondFormatModal",
  components: { CondFormatEditor },
  props: {
    show: { type: Boolean, default: false },
    column: { type: Object, default: () => ({}) },
    value: { type: Array, default: () => [] },
    lang: { type: String, default: "de" },
  },
  data() {
    return {
      workingRules: [] as any[],
    };
  },
  computed: {
    columnLabel(): string {
      const c: any = this.column || {};
      if (!c.name && !c.uid) return "";
      // Resolve multilingual name: name_<lang> → name → uid
      // Supported language fields: name_en, name_fr, name_pt, name_hr (plus default "de" → name)
      const langKey = `name_${(this as any).lang}`;
      return c[langKey] || c.name || c.uid || "";
    },
  },
  watch: {
    // When the modal opens, snapshot the incoming rules into the working copy.
    show(newVal: boolean) {
      if (newVal) {
        this.workingRules = Array.isArray((this as any).value)
          ? JSON.parse(JSON.stringify((this as any).value))
          : [];
      }
    },
    value: {
      immediate: true,
      handler(newVal: any[]) {
        this.workingRules = Array.isArray(newVal)
          ? JSON.parse(JSON.stringify(newVal))
          : [];
      },
    },
  },
  methods: {
    handleShowChange(newShow: boolean) {
      // v-dialog emits input(false) when Esc is pressed (outside-click is suppressed
      // by `persistent`). Treat as cancel.
      if (!newShow) {
        this.onCancel();
      }
    },
    onConfirm() {
      // Emit the finalized rules; parent is responsible for persisting.
      this.$emit("confirm", JSON.parse(JSON.stringify(this.workingRules)));
      this.$emit("update:show", false);
    },
    onCancel() {
      // Discard working copy; next open will re-snapshot from `value`.
      this.$emit("cancel");
      this.$emit("update:show", false);
    },
  },
};
